module.exports = __webpack_public_path__ + "media/images/background/6-1e68f6610605a8ea061ebc510d72374d.jpg";